import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            As a DevOps Engineer at <a href="https://www.yomafleet.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#c770f0" }}>Yoma Fleet Co., Ltd</a>, I design and implement scalable solutions that bridge development and operations.
            I played a key role in building the company's microservices architecture to improve scalability, flexibility, and system integration.

            I've automated CI/CD pipelines across products, using tools like Terraform for Infrastructure as Code and integrating testing and monitoring for reliable software delivery.
            My work focuses on system integrity, performance, and alignment with business goals.

            I collaborate with cross-functional teams to streamline workflows and resolve issues, while also embedding security and compliance into infrastructure and pipelines.
            I deploy tools like Grafana, Prometheus, and Sentry for system monitoring, and I provide documentation to support DevOps adoption.
            <style>
              {`
                @media (max-width: 768px) {
                  .quote-card-view p {
                    font-size: 1.2rem !important;
                  }
                }
              `}
            </style>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;